<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1647_987)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8 0C3.58203 0 0 3.58332 0 8C0 12.4193 3.58203 16 8 16C12.418 16 16 12.4193 16 8C16 3.58332 12.418 0 8 0ZM8.32 3.84C9.02693 3.84 9.6 4.41307 9.6 5.12C9.6 5.82693 9.02693 6.4 8.32 6.4C7.61307 6.4 7.04 5.82693 7.04 5.12C7.04 4.41307 7.61307 3.84 8.32 3.84ZM9.82857 12.16C10.0558 12.16 10.24 11.9881 10.24 11.776V11.008C10.24 10.7959 10.0558 10.624 9.82857 10.624H9.41714V7.424C9.41714 7.21194 9.23293 7.04 9.00571 7.04H6.81143C6.58422 7.04 6.4 7.21194 6.4 7.424V8.192C6.4 8.40406 6.58422 8.576 6.81143 8.576H7.22286V10.624H6.81143C6.58422 10.624 6.4 10.7959 6.4 11.008V11.776C6.4 11.9881 6.58422 12.16 6.81143 12.16H9.82857Z" fill="#FFAE64"/>
</g>
<defs>
<clipPath id="clip0_1647_987">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
